module.exports = __webpack_public_path__ + "static/img/ef3bd5f70b7a1aa44a632cf62e0338f6.58f3eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/ef3bd5f70b7a1aa44a632cf62e0338f6.png
// module id = eITj
// module chunks = 64